import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { TranslationKeys } from '../../../translations';
import { RestrictAccessSuperAdmin, useBreadcrumb } from '../../../components';
import { AdminPanelManagementPage } from './AdminPanelManagementPage';
import { BulkLeftCompanyPage } from './BulkLeftCompanyPage';
import { ConnectionInspectorPage } from './ConnectionInspectorPage';
import { RestoreConnectionsPage } from './RestoreConnectionsPage';
import { NaverrekenenTemplateUploadPage } from './NaverrekenenTemplateUpload';
import { FileUploadCleanupPage } from './FileUploadCleanupPage';
import { ProductInvoicingPage } from './ProductInvoicingPage';

export const AdminPanelPages = () => {
  useBreadcrumb(TranslationKeys.menu_adminPanel);

  return (
    <Routes>
      <Route element={<RestrictAccessSuperAdmin />}>
        <Route element={<AdminPanelManagementPage />} path={'overview'} />
        <Route element={<ConnectionInspectorPage />} path={'connection-inspector'} />
        <Route element={<RestoreConnectionsPage />} path={'restore-connections'} />
        <Route element={<NaverrekenenTemplateUploadPage />} path={'naverrekenen-template'} />
        <Route element={<BulkLeftCompanyPage />} path={'bulk-left-company'} />
        <Route element={<FileUploadCleanupPage />} path={'undo-uploaded-file'} />
        <Route element={<ProductInvoicingPage />} path={'product-invoicing'} />
      </Route>

      <Route index element={<Navigate to="overview" replace />} />
      <Route path="*" element={<Navigate to="overview" replace />} />
    </Routes>
  );
};
